// 候选人-发送背调通知
export default class SendBgCheckMessageForm {
  candidateId = 0;
  companyId = 0;
  userId = 0;
}
